export const ROUTE_PATHS = {
    LOGIN: '/login',
    MAIN:'/album',
    ONBOARDING: '/onboarding',
    LOGIN_SUCCESS:'/login/success',
    INTRO: '/',
    ALBUM: '/album',
    Detail: '/album/:id',
} as const;
